const template = `
  query KeywordSearch($input: KeywordSearchInput!) {
    keywordSearch(input: $input) {
      courses {
        slug
        title
        tags
        startTime
        endTime
        location
        address
        teacher {
          name
          title
          avatar {
            small {
              url
            }
          }
        }
        courseImages {
          photo {
            large {
              url
            }
            small {
              url
            }
          }
        }
      }
    }
  }
`

export default async function courseSearch({ keyword, teacherId, offset, limit }) {
  const input = {
    keyword: keyword || '',
    type: 'course',
    paginationInput: { limit, offset }
  }
  if (teacherId) input.params = { teacherId }
  const { keywordSearch } = await request(template, { input })

  return keywordSearch.courses.map(c => {
    c.coverUrls = c.courseImages?.slice(0, 3).map(image => image.photo)
    const { small } = c.teacher.avatar
    c.teacher.$avatar = small ? small.url : cdn('user/default/profile_pic2.png')
    return c
  })
}
